import WorkerConnection from '../WorkerConnection';
export const sendCrossTabMessage = message => WorkerConnection.sendMessage(message);